import { useEffect, useState } from "react";
import { useAnmeldung } from "../zustand/Anmeldung";
import { holeDateiZugang } from "../dienst/server";

/*
  Der Zugang zu geschützten Dateien.

  Hochgeladene Dateien liefert der Server nur noch mit einem kurzlebigen
  Token. Dieser Haken hält eines vorrätig und erneuert es, bevor es abläuft
  — damit jede Adresse, die eine Ansicht gerade zeichnet, gültig ist.

  ---------------------------------------------------------------
  Warum das ein Haken ist und nicht ein Aufruf beim Anklicken
  ---------------------------------------------------------------

  Beim Anklicken zu holen klingt sparsamer, hat aber zwei Haken: Ein Bild
  auf einer Folie wird nicht angeklickt, es steht einfach da und braucht
  seine Adresse beim Zeichnen. Und ein Fenster, das erst nach einer Antwort
  vom Server geöffnet wird, hält der Browser für ein aufgedrängtes und
  blockiert es.

  So bleibt der Verweis in der Dateiansicht ein gewöhnlicher Verweis: Man
  kann ihn in einem neuen Reiter öffnen, wie man es von jedem anderen
  gewohnt ist.
*/

/* Etwas kürzer als die Gültigkeit von zweieinhalb Minuten im Dienst. */
const ERNEUERN_MS = 140 * 1000;

export default function useDateiZugang() {
  const { token } = useAnmeldung();
  const [zugang, setzeZugang] = useState(null);

  useEffect(() => {
    if (!token) {
      setzeZugang(null);
      return undefined;
    }

    let laeuft = true;

    async function holen() {
      try {
        const neu = await holeDateiZugang(token);
        if (laeuft) setzeZugang(neu);
      } catch {
        /*
          Beim nächsten Durchlauf wieder. Ein Fehler hier darf die Ansicht
          nicht anhalten — sichtbar wird er ohnehin: Ohne Zugang zeigt die
          Datei ihren Hinweis statt eines toten Verweises.
        */
      }
    }

    holen();
    const uhr = setInterval(holen, ERNEUERN_MS);

    return () => {
      laeuft = false;
      clearInterval(uhr);
    };
  }, [token]);

  return zugang;
}
